import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import de from './de.json';
import en from './en.json';

const resources = {
  de: {
    translation: de
  },
  en: {
    translation: en
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'de', // Standard-Sprache ist Deutsch
    fallbackLng: 'de',
    
    detection: {
      // Erst aus localStorage lesen, dann Browser-Language
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'togee-language',
      caches: ['localStorage']
    },

    interpolation: {
      escapeValue: false // React already does escaping
    }
  });

export default i18n; 